import React from "react"

export interface BaseInputProps {
  fieldId: string,
  disabled?: boolean,
  readonly?: boolean,
  onChange?: (ev: React.ChangeEvent<HTMLInputElement>) => void,
  onBlur?: (ev: React.ChangeEvent<HTMLInputElement>) => void,
  placeholderText?: string
  value?: string,
  tabIndex?: number,
  autofocus?: boolean
}

const BaseInput = (props: BaseInputProps) => {
  const { fieldId, disabled, readonly, placeholderText, value, onChange = () => {}, onBlur = () => {}, tabIndex = 0, autofocus = false } = props

  return (
    <input
      id={fieldId}
      tabIndex={tabIndex}
      autoFocus={autofocus}
      className="input"
      name={fieldId}
      type="text"
      value={value}
      placeholder={placeholderText}
      onChange={(ev) => {onChange(ev)}}
      onBlur={(ev) => {onBlur(ev)}}
      disabled={disabled === true}
      readOnly={readonly === true}
    />
  )
}

export default BaseInput